const CHUNK_SIZE = 10 * 1024 * 1024 // 10 MB per part (keep in sync with the server's AssetChunkBytes)

// Uploads a file to the asset library in chunks and resolves with the saved asset (AssetVM).
// `axios` is the $axios instance. `metadata` accepts the same fields the single-request
// /upload/asset endpoint understands: title, assetFolderId and fileInfo (all optional).
export async function uploadAssetInChunks(axios, file, metadata = {}) {
  const uploadUuid = generateUuid()
  const totalParts = Math.ceil(file.size / CHUNK_SIZE)

  for (let partIndex = 0; partIndex < totalParts; partIndex++) {
    const start = partIndex * CHUNK_SIZE
    const part = file.slice(start, start + CHUNK_SIZE)

    const partData = new FormData()
    partData.append('chunk', part)
    partData.append('uploadUuid', uploadUuid)
    partData.append('partIndex', partIndex)

    await axios.$post('/upload/asset-chunk', partData, {
      headers: {'content-type': 'multipart/form-data'},
    })
  }

  const finalizeData = new FormData()
  finalizeData.append('uploadUuid', uploadUuid)
  finalizeData.append('totalParts', totalParts)
  finalizeData.append('fileSize', file.size)
  finalizeData.append('fileName', metadata.fileName || file.name)
  finalizeData.append('contentType', file.type)
  if (metadata.title != null) finalizeData.append('title', metadata.title)
  if (metadata.assetFolderId != null) finalizeData.append('assetFolderId', metadata.assetFolderId)
  if (metadata.fileInfo != null) finalizeData.append('fileInfo', JSON.stringify(metadata.fileInfo))

  return axios.$post('/upload/asset-chunks-done', finalizeData, {
    headers: {'content-type': 'multipart/form-data'},
  })
}

function generateUuid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }

  // Fallback for non-secure contexts where crypto.randomUUID is unavailable
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0
    const value = char === 'x' ? random : (random & 0x3) | 0x8
    return value.toString(16)
  })
}